import React from 'react';
import { aboutContent } from '../data/mock';

const About = () => {
  return (
    <section id="about" className="py-24 bg-white relative overflow-hidden">
      {/* 3D Floral background decorations */}
      <div className="absolute top-0 right-0 w-96 h-96">
        <div className="absolute top-10 right-10 w-64 h-64 bg-lavender-100/40 rounded-full blur-3xl" />
        <div className="absolute top-20 right-5 w-8 h-16 bg-lavender-300/30 rounded-full blur-[2px] rotate-45 floral-accent" />
        <div className="absolute top-8 right-20 w-6 h-12 bg-lilac-200/35 rounded-full blur-[2px] -rotate-12 floral-accent" />
      </div>
      <div className="absolute bottom-0 left-0 w-80 h-80">
        <div className="absolute bottom-10 left-10 w-48 h-48 bg-lilac-100/50 rounded-full blur-3xl" />
        <div className="absolute bottom-20 left-5 w-6 h-12 bg-violet-200/30 rounded-full blur-[2px] -rotate-45 floral-accent" />
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image with 3D depth effect */}
          <div className="relative order-2 lg:order-1">
            <div className="relative group">
              {/* Floral glow layers */}
              <div className="absolute -inset-6 bg-gradient-to-br from-lavender-200/40 via-lilac-100/30 to-violet-100/20 rounded-3xl transform rotate-3 group-hover:rotate-2 transition-transform duration-500 blur-sm" />
              <div className="absolute -inset-4 bg-gradient-to-br from-lavender-50 to-lilac-50/50 rounded-3xl transform -rotate-2 group-hover:-rotate-1 transition-transform duration-500" />
              
              <div className="relative overflow-hidden rounded-2xl shadow-2xl shadow-lavender-900/15 group-hover:shadow-3xl transition-all duration-500">
                <img
                  src={aboutContent.imageUrl}
                  alt="Hem of Grace Events Florida luxury event designer floral arrangement"
                  className="relative w-full h-auto object-cover aspect-[4/5] transform group-hover:scale-[1.02] transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-lavender-900/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
            </div>
            
            {/* Floating accent card */}
            <div className="absolute -bottom-6 -right-6 lg:-right-10 w-36 h-36 bg-white rounded-2xl shadow-2xl shadow-lavender-900/15 flex items-center justify-center transform hover:scale-105 hover:-translate-y-1 transition-all duration-300 border border-lavender-100">
              <div className="text-center">
                <span className="block text-lavender-600 text-3xl" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Faith</span>
                <span className="block text-lilac-400 text-lg" style={{ fontFamily: "'Cormorant Garamond', serif" }}>&</span>
                <span className="block text-lavender-600 text-3xl" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Love</span>
              </div>
            </div>
          </div>
          
          {/* Content */}
          <div className="order-1 lg:order-2">
            <span
              className="inline-block text-lavender-600 text-sm tracking-[0.2em] uppercase mb-4"
              style={{ fontFamily: "'Lato', sans-serif" }}
            >
              Our Story
            </span>
            
            <h2
              className="text-4xl sm:text-5xl text-grape-800 mb-3 leading-tight"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {aboutContent.title}
            </h2>
            
            <p
              className="text-xl text-lavender-600 mb-4"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              {aboutContent.subtitle}
            </p>

            {/* Bilingual / Spanish line */}
            <div className="inline-flex items-center px-4 py-2 mb-8 rounded-full bg-lilac-50 border border-lavender-100 shadow-sm">
              <span
                className="text-sm font-medium text-lavender-700"
                style={{ fontFamily: "'Lato', sans-serif" }}
              >
                Bilingual wedding & event planning — <span className="italic">Se habla español</span>
              </span>
            </div>
            
            <div className="space-y-6">
              {aboutContent.paragraphs.map((paragraph, index) => (
                <p
                  key={index}
                  className="text-grape-700/80 text-lg leading-relaxed"
                  style={{ fontFamily: "'Lato', sans-serif" }}
                >
                  {paragraph}
                </p>
              ))}
            </div>
            
            {/* Decorative divider with floral accent */}
            <div className="mt-10 flex items-center space-x-4">
              <div className="h-px flex-1 bg-gradient-to-r from-lavender-300 to-transparent" />
              <div className="relative">
                <div className="absolute -inset-2 bg-lavender-200/50 rounded-full blur-md" />
                <div className="relative w-12 h-12 rounded-full overflow-hidden shadow-lg border-2 border-lavender-200">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_graceful-events/artifacts/3rm2m55c_image9.jpeg" 
                    alt="Hem of Grace Events luxury event design detail" 
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="h-px flex-1 bg-gradient-to-l from-lavender-300 to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
